import { Component, Inject } from '@angular/core';
import { BaseComponent } from '../../../base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Folder } from '../../../../models/ui/folder.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CasesService } from '../../../../services/cases.service';
import { map } from 'rxjs/operators';
import { ImportManager } from '../../../../managers/import.manager';

@Component({
    selector: 'lex-import-folders',
    templateUrl: './import-folders-dialog.component.html',
    styleUrls: ['./import-folders-dialog.component.scss'],
    standalone: false
})
export class ImportFoldersDialogComponent extends BaseComponent {
	public importFoldersForm: UntypedFormGroup;
	public cases$ = this.casesService.getAllCases().pipe(
		map((x) => x.value)
	);

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<ImportFoldersDialogComponent>,
		private casesService: CasesService,
		private importManager: ImportManager,
		@Inject(MAT_DIALOG_DATA) private data: { folder: Folder }) {
		super();
		this.importFoldersForm = this.formBuilder.group({
			targetCaseId: ['', [Validators.required]]
		});
	}

	public save(): void {
		this.importManager.importFolders(this.importFoldersForm.controls['targetCaseId'].value).subscribe(() => this.dialogRef.close());
	}
}
